import React from 'react';
import ProjectListContainer from '../../containers/techmng/ProjectListContainer';


const TechProjectListPage = () => {
  return <ProjectListContainer/>
};

export default TechProjectListPage;
